import { ProfileInfoCopyButton } from "@components/common/profile-info-copy-button";
import { Impersonation } from "@components/impersonation/impersonation";
import { LegacyAdminPanelLink } from "@components/links/legacy-admin-panel-link";
import { BaseCompanyProps } from "@custom-types/base-types";
import { EditWorkspace } from "@pages/workspace-profile/tab-contents/edit-workspace";
import { DeleteWorkspace } from "@pages/workspace-profile/tab-contents/workspace-info-tab/delete-workspace/delete-workspace";
import { isProductionEnvironment } from "@utils/env-utils";

/** List of actions performed on a workspace in workspace information tab */
export function WorkspaceInfoActions({
  company,
}: BaseCompanyProps): React.JSX.Element {
  return (
    <>
      <LegacyAdminPanelLink subjectType="COMPANY" id={company.id} />
      <ProfileInfoCopyButton subjectType="COMPANY" entity={company} />
      <EditWorkspace company={company} />
      <Impersonation type="workspaceViewer" subjectId={company.id} />

      {!isProductionEnvironment && <DeleteWorkspace company={company} />}
    </>
  );
}
